<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_contract"
            role="tab"
          >
            <h5><span class="far fa-pen-nib"></span> Contrato</h5>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="contractId > 0">
          <a class="nav-link m-tabs__link" data-toggle="tab" href="#contract_history" role="tab">
            <h5><span class="far fa-history"></span> Histórico</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_contract" role="tabpanel">
          <CustomerContractPlanSaveForm
            :contract="data"
            @savedContract="savedContract"
            :changeReason="change_reason"
          />
        </div>
        <div class="tab-pane" id="contract_history" role="tabpanel">
          <CustomerContractPlanHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerContractPlanSaveForm from '@/components/contracts/plans/CustomerContractPlanSaveForm';
import CustomerContractPlanHistory from '@/components/contracts/plans/CustomerContractPlanHistory';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'CustomerContractPlanModal',
  data() {
    return {
      data: {},
      change_reason: null,
    };
  },
  components: {
    CustomerContractPlanSaveForm,
    CustomerContractPlanHistory,
  },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showContractSave = null;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/contract/plan/data/${this.contractId}`;
      axios(url).then((res) => {
        if (res.data) {
          res.data.change_reason = null;
          this.data = res.data;
          this.$store.state.showContractProductId = res.data.product_id;
        }
      });
    },
    savedContract(data) {
      this.change_reason = data.change_reason;
      this.data = data;
      this.$store.state.showContractProductId = data.product_id;
    },
    changedReason(changed_reason) {
      this.change_reason = changed_reason;
    },
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
  },
  beforeMount() {
    this.getDatas();
  },
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
